// extracted by mini-css-extract-plugin
export var TextColor = "timeless-module--TextColor--hQdRR";
export var centeredarrow = "timeless-module--centeredarrow--Vn7Ns";
export var fontSize = "timeless-module--fontSize--FNVCM";